module.exports = __webpack_public_path__ + "in.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/in.svg
// module id = 867
// module chunks = 0